import styled, {css} from "styled-components"

import {ExpanderArrow} from "@irati/ui/src/Expander"

export const ExpanderWrapper = styled.div`
  ${({theme}) => css`
    padding: ${theme.spacing.two};
    background-color: ${theme.colors.utility.white};
    border-radius: ${theme.border.radius.small};
    box-shadow: ${theme.shadows.mid};
    ${theme.mediaQueries.minWidthMedia.tablet`
      padding: ${theme.spacing.four};
    `}
  `}

  ${ExpanderArrow} {
    margin: 0 0 0 10px;
    ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
      margin: 0 10px 0 10px;
    `}
  }
`
